// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"275":"e117996a","787":"bf826276"}[chunkId] + ".chunk.js";
};